import { url } from '@/api/api.js'

const myHeaders = new Headers();
    myHeaders.append("Cookie", "mailchimp_landing_site=https%3A%2F%2Fcleancutmeals.ie%2Fwc-auth%2Fv1%2Fauthorize%3Fck_4300411a88c76eace32567945afbe0ea92aeb372%3Dcs_50a10ddbd8d0ca76b6435e53273bf9408645d28d");

const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
};

export default {
    state: {    
        mainProducts: [],
        breakfastProducts: [],
        snacksProducts: [],
        error: null,
        mealsCount: 0,
        menus: [
            {
                title: 'Breakfast',
                description: '',
                count: 1
            },
            {
                title: 'Main meals',
                description: '',
                count: 3
            },
            {
                title: 'Snacks',
                description: '+690 kcals',
                count: 2
            }
        ],
        allergies: [
            {
                title: 'Eggs',
                slug: 'eggs',
                isActive: false
            },
            {
                title: 'Gluten',
                slug: 'gluten',
                isActive: false
            },
            {
                title: 'Milk',
                slug: 'milk',
                isActive: false
            },
            {
                title: 'Nuts',
                slug: 'nuts',
                isActive: false
            },
            {
                title: 'Peanuts',
                slug: 'peanuts',
                isActive: false
            },     
            {
                title: 'Fish',
                slug: 'fish',
                isActive: false
            },
            {
                title: 'Molluscs',
                slug: 'molluscs',
                isActive: false
            },            
            {
                title: 'Mustard',
                slug: 'mustard',
                isActive: false
            },
            {
                title: 'Lupin',
                slug: 'lupin',
                isActive: false
            },
            {
                title: 'Celery',
                slug: 'celery',
                isActive: false
            },
            {
                title: 'Crustaceans',
                slug: 'crustaceans',
                isActive: false
            },
            {
                title: 'Sulphur dioxide & Sulphites',
                slug: 'sulphites',
                isActive: false
            },
            {
                title: 'Sesame Seeds',
                slug: 'sesame-seeds',
                isActive: false
            },
            {
                title: 'Soybeans',
                slug: 'soybeans',
                isActive: false
            }
        ],
        proteinsType: [
            {
                title: 'Meat and Fish',
                slug: 'meatandfish',
                isActive: false
            },
            {
                title: 'Meat only',
                slug: 'meat',
                isActive: false
            },
            {
                title: 'Vegetarian',
                slug: 'vegetarian',
                isActive: false
            },
            {
                title: 'I eat everything',
                slug: 'empty',
                isActive: false
            },
        ],
        orderProducts: {
            mainProducts: [],
            breakfastProducts: [],
            snacksProducts: [],
        },
    },
    mutations: {
        setError(state, error) {
            state.error = error
            console.log(error);
        },
        setProducts ( state, payload) {
            if ( payload.mealType == 'snacks' ) {
                state.snacksProducts = payload.products;
            } else if ( payload.mealType == 'breakfast' ) {
                state.breakfastProducts = payload.products;
            } else {
                state.mainProducts = payload.products;
            }            
        },
        setOrderProducts ( state, payload) {
            
            if(payload.length > 0) {
                state.orderProducts.snacksProducts = payload || [];
            }

            if (payload.mealType == 'snacks') {
                state.orderProducts.snacksProducts = payload.products;
                state.changeSP = payload || 1;
            } else if (payload.mealType == 'breakfast') {
                state.orderProducts.breakfastProducts = payload.products;
                state.changeBP = payload || 1;
            } else {
                state.orderProducts.mainProducts = payload.products;
                state.changeMP = payload || 1;
            }

        },
    },
    actions: {
        async getProducts({commit}, payload) {
                    
            let query = '?meal_type=' + payload.mealType;

            // if (payload.plan && payload.plan.length > 0 ) {                
            //     query = '&plan=' + payload.plan.title;
            // }

            if (payload.allergies && payload.allergies && payload.allergies.length > 0 ) {

                let allergy = '';

                payload.allergies.forEach((item ) => {
                    
                    if ( item.isActive == true ) {
                        allergy += item.slug + ',';
                    }
                });
                
                if(allergy.length > 0) {
                    query += '&allergy=' + allergy.slice(0, -1);
                }  

            }

            if( payload.protein && payload.protein.length > 0 ) {
                query += '&protein=' + payload.protein;
            }

            if ( payload.all ) {
                query += '&all=' + payload.all;
            }

            try {
                const Products = await fetch(url + "/wp-json/cct-wizard/v1/selproducts/" + query, requestOptions);
                const data = await Products.text();
                const products = await JSON.parse(data);

                if ( payload.count ) {
                    const orderProducts = await products.filter((item, index) => {
                        return (item && index < payload.count);
                    });

                    commit('setOrderProducts', { 
                        mealType: payload.mealType, 
                        products: orderProducts,
                        count: payload.count
                    } );

                } else {
                    commit('setProducts', { mealType: payload.mealType, products });
                }

            } catch ( error ) {
                console.log('error', error.message);
                commit('setError', error.message);
                throw error;
            }
            commit('viewLoader', false); 
        },
    },
    getters: {
        getMainProducts ( state ) {
            return state.mainProducts;
        },
        getBreakfastProducts ( state ) {
            return state.breakfastProducts;
        },
        getSnacksProducts ( state ) {
            return state.snacksProducts;
        },
        getAllergies ( state ) {
            return state.allergies;
        },
        getMealsCount ( state ) {
            return state.mealsCount;
        },
        getMenus ( state ) {
            return state.menus;
        },
        orderProducts ( state ) {
            return state.orderProducts;
        },
        proteinsType ( state ) {
            return state.proteinsType;
        },
    }
}
